<template>
  <el-container v-loading="isLoading" class="Edit">
    <el-header class="Edit-header">
      <el-page-header @back="close" :content="title"></el-page-header>
    </el-header>
    <el-main class="Edit-main">
      <el-form :model="form" :rules="rules" ref="form" label-width="150px">
        <el-form-item label="名称" prop="name" style="width: 500px">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="是否允许透支" prop="name" style="width: 500px">
          <el-select v-model="form.overdraft">
            <el-option label="否" :value="0"></el-option>
            <el-option label="是" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="描述" prop="remark" style="width: 500px">
          <el-input type="textarea" v-model="form.remark"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('form')">提交</el-button>
          <el-button v-if="isModel!==2" @click="resetForm('form')">重置</el-button>
        </el-form-item>
      </el-form>
    </el-main>
  </el-container>
</template>

<script>
export default {
  name: 'Edit',
  data () {
    let _this = this
    let nameRule = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入姓名'))
      } else {
        if (this.isModel !== 2 || this.oldName !== value) {
          _this.$axios({
            method: 'post',
            headers: {
              'Authorization': this.$store.state.user.token,
              'ModuleId': this.thisModule.id
            },
            url: this.myOption.requestUrl + this.thisModule.exists,
            data: _this.qs.stringify({
              advertiserName: value
            })
          }).then((res) => {
            let code = res.data.code
            if (code === 200) {
              if (res.data.data.exists) {
                callback(new Error('姓名已存在'))
              } else {
                callback()
              }
            } else {
              _this.myOption.abnormalCode(_this, code)
            }
          }).catch((err) => {
            _this.myOption.abnormalCode(_this, err)
          })
        } else {
          callback()
        }
        // }
      }
    }
    return {
      id: '',
      title: '',
      oldName: '',
      thisModule: {},
      isModel: this.$store.getters.isEditId,
      isLoading: false,
      form: {
        name: '',
        overdraft: 0,
        remark: ''
      },
      rules: {
        name: [
          { required: true, validator: nameRule, trigger: 'blur' },
          { min: 2, max: 18, message: '长度在 2 到 18 个字符', trigger: 'blur' }
        ],
        overdraft: [
          { required: true, message: '请选择是否允许透支', trigger: 'change' }
        ],
        remark: [
          { required: false, message: '请输入描述', trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    let thisModule = this.myOption.requestModule.user.children.adOwner.children
    if (this.isModel === 2) {
      this.isLoading = true
      this.id = this.$store.state.user.editId
      this.title = '修改广告主'
      this.thisModule = thisModule.modify
      this.thisModule.detail = thisModule.detail
      this.getDetail()
    } else {
      this.title = '新建广告主'
      this.thisModule = thisModule.add
    }
  },
  methods: {
    close () {
      this.myOption.switchListAndEdit(this, true)
    },
    // 获取详情信息
    getDetail () {
      this.isLoading = true
      this.$axios({
        method: 'post',
        headers: {
          'Authorization': this.$store.state.user.token,
          'ModuleId': this.thisModule.detail.id
        },
        url: this.myOption.requestUrl + this.thisModule.detail.api,
        data: this.qs.stringify({
          advertiserId: this.id
        })
      }).then((res) => {
        let code = res.data.code
        if (code === 200) {
          let data = res.data.data
          this.oldName = data.advertiserName
          this.form.name = data.advertiserName
          this.form.overdraft = data.overdraft
          this.form.remark = data.remark
          this.isLoading = false
        } else {
          this.myOption.abnormalCode(this, code)
        }
      }).catch((err) => {
        this.myOption.abnormalCode(this, err)
        this.isLoading = false
      })
    },
    // 提交表单
    submitForm (formName) {
      let params = {
        advertiserName: this.form.name,
        overdraft: this.form.overdraft,
        remark: this.form.remark
      }
      if (this.isModel === 2) {
        params.advertiserId = this.id
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.isLoading = true
          this.$axios({
            method: 'post',
            headers: {
              'Authorization': this.$store.state.user.token,
              'ModuleId': this.thisModule.id
            },
            url: this.myOption.requestUrl + this.thisModule.api,
            data: this.qs.stringify(params)
          }).then((res) => {
            let code = res.data.code
            this.isLoading = false
            if (code === 200) {
              this.$message.success(`${this.isModel === 2 ? '修改' : '新建'}广告主成功`)
              this.$router.push({path: this.$route.path.replace('/edit', '/list')})
            } else {
              this.myOption.abnormalCode(this, code)
            }
          }).catch((err) => {
            this.isLoading = false
            this.myOption.abnormalCode(this, err)
          })
        } else {
          return false
        }
      })
    },
    // 重置表单
    resetForm (formName) {
      this.$refs[formName].resetFields()
    }
  },
  beforeDestroy () {
    this.$store.dispatch('SetEditId', false)
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ad_owner/Edit.vue